import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="border-b border-gray-100">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4">
          <div className="max-w-4xl mx-auto flex items-center justify-between">
            <button onClick={() => navigate('/')} className="text-xl font-bold text-navy-600 cursor-pointer">
              EzyAbroad
            </button>
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-500 hover:text-navy-600 cursor-pointer"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </header>

      <main className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-navy-600">Privacy Policy</h1>
          <p className="mt-2 text-sm text-gray-400">Last updated: April 27, 2025</p>

          <div className="mt-10 space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">1. Introduction</h2>
              <p>
                EzyAbroad Technologies Pvt. Ltd. (&ldquo;EzyAbroad,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">2. Information We Collect</h2>
              <p className="mb-3">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details you provide when registering or contacting us.</li>
                <li><strong>Account Information:</strong> Login credentials, profile information, and preferences for consultancy accounts.</li>
                <li><strong>Usage Data:</strong> Information about how you interact with our platform, including pages visited, features used, and time spent.</li>
                <li><strong>Device Information:</strong> IP address, browser type, operating system, and device identifiers.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">3. How We Use Your Information</h2>
              <p className="mb-3">We use your information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and maintain our services</li>
                <li>Process your registrations and appointments</li>
                <li>Communicate with you about updates, offers, and support</li>
                <li>Improve our platform and develop new features</li>
                <li>Ensure security and prevent fraud</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">4. Information Sharing</h2>
              <p>
                We do not sell your personal information. We may share your data with trusted service providers who assist us in operating our platform, or when required by law. Consultancies on our platform can see student enquiries directed to them.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">6. Your Rights</h2>
              <p className="mb-3">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your data</li>
                <li>Object to certain processing activities</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">7. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{" "}
                <a href="mailto:hello@ezyabroad.com" className="text-gold-600 hover:text-gold-500">hello@ezyabroad.com</a>
                {" "}or write to us at EzyAbroad Technologies Pvt. Ltd., Hyderabad, Telangana, India.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
